import { AnalyticsAPI } from "../analytics.model";

export class EnsightenAnalytics implements AnalyticsAPI {
  test(): boolean {
    const webAnalytics = (window as any).webAnalytics;
    return !!webAnalytics && !!webAnalytics.publish;
  }

  track(eventName: string, eventProperties: any) {
    const dataLayer = (window as any).dataLayer;
    if (eventName === "productSet") {
      dataLayer[eventName] = eventProperties;
    }
  }

  identify() {}
  page() {}
  alias() {}
  group() {}
}



// WEBPACK FOOTER //
// ./src/providers/ensighten.ts